import { KojinPptxFormat } from "./types"

import { format as DefaultFormat } from "./format/default"
import { format as HeaderOnlyFormat } from "./format/headerOnly"
import { format as ChugaiFormat } from "./format/chugai"

export const KojinPptxFormatList: KojinPptxFormat[] = [
  DefaultFormat,
  HeaderOnlyFormat,
  ChugaiFormat
]
